import store from '@/store/store'
import app from '@/main'
import i18n from '@/i18n/i18n'

export default socket => {
  socket.on('payping_connected', function(data) {
    store.commit('UPDATE_USER_INFO', { paypingOauthId: data })
    app.$notifySuccess(i18n.t('messages.successfully_payping_connected'))
  })
}
